import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ProvisioningStatusPage } from './ProvisioningStatusPage/ProvisioningStatusPage';

export function ProvisioningRoutes(): React.ReactElement {
  return (
    <div data-testid="provisioning-routes">
      <Switch>
        <Route path="/provisioning" exact>
          <ProvisioningStatusPage />
        </Route>
      </Switch>
    </div>
  );
}
